import client from '@/lib/http-client';

const endpoint = 'admin/popup-information';

export const getData = (params, callback, err) => {
	client.get(endpoint, { params })
		.then((res) => {
			if (callback) callback(res.data);
		}).catch((e) => {
			if (err) err(e);
		});
};

export const create = (params, callback, err) => {
	client.post(endpoint, params)
		.then((res) => {
			if (callback) callback(res.data);
		})
		.catch((e) => {
			if (err) err(e);
		});
};

export const update = (id, params, callback, err) => {
	const url = `${endpoint}/${id}`;
	client.put(url, params)
		.then((res) => {
			if (callback) callback(res.data);
		})
		.catch((e) => {
			if (err) err(e);
		});
};


export const moveInformation = (id, params, callback, err) => {
	const url = `${endpoint}/move-item/${id}`;
	client.put(url, params)
		.then((res) => {
			if (callback) callback(res.data);
		})
		.catch((e) => {
			if (err) err(e);
		});
};

export const deleteInformation = (id, callback, err) => {
	const url = `${endpoint}/${id}`;
	client.delete(url)
		.then((res) => {
			if (callback) callback(res.data);
		})
		.catch((e) => {
			if (err) err(e);
		});
};
